import React from "react";

async function resetAndReload() {
  try {
    if (window.caches) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
    if (navigator.serviceWorker?.getRegistrations) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch (e) {
    /* best effort */
  }
  window.location.reload();
}

// Never show a blank screen: any render crash lands here with a one-tap recovery.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        data-testid="app-error-boundary"
        style={{
          minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
          background: "#F7F5F0", padding: 24, fontFamily: "'Inter', system-ui, sans-serif",
        }}
      >
        <div style={{ maxWidth: 460, background: "#fff", borderRadius: 16, padding: "32px 28px", boxShadow: "0 18px 50px rgba(11,30,59,0.12)" }}>
          <div style={{ fontSize: 11, letterSpacing: 2, color: "#E01A2E", fontWeight: 700 }}>RESQ1</div>
          <h1 style={{ fontSize: 22, margin: "10px 0 8px", color: "#0B1E3B" }}>This screen failed to load.</h1>
          <p style={{ fontSize: 14, lineHeight: 1.6, color: "#5B6B7E", margin: "0 0 22px" }}>
            Usually an old copy of the app cached by your browser. Resetting clears it and reloads
            the latest version — your login stays intact.
          </p>
          <button
            onClick={resetAndReload}
            data-testid="error-reset-btn"
            style={{ background: "#0B1E3B", color: "#fff", border: 0, borderRadius: 999, padding: "12px 24px", fontSize: 14, fontWeight: 700, cursor: "pointer" }}
          >
            Reset and reload
          </button>
          <pre style={{ marginTop: 22, fontSize: 11, color: "#8A94A2", whiteSpace: "pre-wrap", maxHeight: 120, overflow: "auto" }}>
            {String(this.state.error?.message || this.state.error)}
          </pre>
        </div>
      </div>
    );
  }
}
